import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  titleHeader: {
    position: "sticky",
    top: 0,
    padding: "6px 0",
    zIndex: 999,
    margin: "16px 0",
    border: "1px solid #FFB7A9",
    borderRadius: 4,
    background: "#FBE8DB",
    textTransform: "uppercase",
    textAlign: "center",
    fontWeight: 600,
    fontSize: 14,
  },

  timeBox: {
    display: "grid",
    gap: 12,
    gridTemplateColumns: "repeat(auto-fill, minmax(90px, 1fr))",
  },
  timeButton: {
    "&.MuiButton-root": {
      maxWidth: "100%",
      height: "45px",
      padding: "6px !important",
      color: "#061340 !important",
      border: "1px solid #DDE0E3 !important",
      borderRadius: 8,
      userSelect: "none",
    },
  },
}));

export { useStyles };
